import { render, staticRenderFns } from "./relatorioSuspensaoJudicial.vue?vue&type=template&id=352522f8"
import script from "./relatorioSuspensaoJudicial.vue?vue&type=script&lang=js"
export * from "./relatorioSuspensaoJudicial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports